import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DocumentsRoutingModule } from "./documents-routing.module";
import { DocumentsComponent } from "./documents.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgxDocViewerModule } from "ngx-doc-viewer";
import { VgCoreModule } from "@videogular/ngx-videogular/core";
import { VgControlsModule } from "@videogular/ngx-videogular/controls";
import { VgOverlayPlayModule } from "@videogular/ngx-videogular/overlay-play";
import { VgBufferingModule } from "@videogular/ngx-videogular/buffering";
import { DocumentUploadComponent } from "./document-upload/document-upload.component";
import { ExcelEditorComponent } from "./excel-editor/excel-editor.component";
import { DocumentsService } from "./documents.service";
import { AlertPopup, HttpLoader } from "app/app.config";
import { TooltipModule } from "primeng/tooltip";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TableModule } from "primeng/table";
import { AssessmentComponent } from "./assessment/assessment.component";
import { SurveyComponent } from "./survey/survey.component";
import { PollComponent } from "./poll/poll.component";
import { LoaderService } from "app/loader/loader.service";
import { AlertService } from "app/notification-alert/alert.service";

@NgModule({
  declarations: [
    DocumentsComponent,
    DocumentUploadComponent,
    ExcelEditorComponent,
    AssessmentComponent,
    SurveyComponent,
    PollComponent,
  ],
  imports: [
    CommonModule,
    DocumentsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxDocViewerModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    TooltipModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule,
    TableModule,
  ],
  providers: [DocumentsService, HttpLoader, AlertPopup, LoaderService, AlertService],
})
export class DocumentsModule {}
